import { Button, Divider, Grid, Paper, Stack, Typography } from "@mui/material";
import { useSnackbar } from "notistack";
import React from "react";
import { ApiError } from "../../Api/ApiError";
import { getStudioTagList } from "../../Api/Store";
import { StudioTag } from "../../Objects/StudioTagInterface";
import { StoreObjectStore } from "../../ObjectStore/StoreObjectStore";
import CategoryTitle from "../atoms/CategoryTitle";
import StudioCard from "../molecules/StudioCard";
import StudioTagEditDialog from "./StudioTagEditDialog";



const StoreDetailStudioTagEdit: React.FC = () => {
    const { enqueueSnackbar } = useSnackbar()
    const { storeObjectState } = React.useContext(StoreObjectStore)
    const [studioTagList, setStudioTagList] = React.useState<StudioTag[]>([])
    const [editStudioTag, setEditStudioTag] = React.useState<StudioTag>()

    const abortController = React.useMemo(() => new AbortController(), [])

    React.useEffect(() => {
        return () => {
            abortController.abort()
        }
    }, [abortController])

    const reloadStudioTagList = React.useCallback((str_id: number) => {
        getStudioTagList({
            str_id: str_id
        }, {signal: abortController.signal}).then(result => {
            setStudioTagList(result.studioTagList)
        }).catch((e: any) => {
            if( e.__CANCEL__ ) {
                console.info("canceled")
            } else if (e instanceof ApiError) {
                enqueueSnackbar(e.message, { variant: "error" })
            } else if (e instanceof Error) {
                enqueueSnackbar(e.message, { variant: "error" })
            }else {
                enqueueSnackbar("通信に失敗しました", { variant: "error" })
            }
        })
    }, [abortController, enqueueSnackbar])

    React.useEffect(() => {
        if (storeObjectState.storeData?.str_id) {
            reloadStudioTagList(storeObjectState.storeData?.str_id)
        }
    }, [storeObjectState.storeData?.str_id, reloadStudioTagList])

    return (
        <Paper sx={{ mt: 2, pb: 2 }}>
            <CategoryTitle
                text="スタジオタグ設定"
            />
            <Grid container spacing={2}
                sx={{
                    my: 2,
                    px: 2
                }}
            >
                {studioTagList.map(studioTag => (
                    <Grid item key={studioTag.stdtag_id} xs={12}>
                        <Paper
                            sx={{
                                p: 2
                            }}
                        >
                            <Stack
                                direction="row"
                                justifyContent="space-between"
                                alignItems="center"
                                sx={{
                                    px: 2,
                                    py: 1
                                }}
                            >
                                <Typography
                                    variant="h6"
                                >{studioTag.stdtag_name}</Typography>
                                <Button
                                    variant="outlined"
                                    onClick={() => {
                                        setEditStudioTag(studioTag)
                                    }}
                                >編集</Button>
                            </Stack>

                            <Divider />
                            <Grid container spacing={2}
                                sx={{
                                    my: 2,
                                    px: 2
                                }}
                            >
                                {studioTag.std_list?.map(std_id => {
                                    let studioData = storeObjectState?.studioList?.find(elem => elem.std_id === std_id)
                                    if (studioData) {
                                        return <Grid item xs={12} sm={6} md={4}
                                            key={std_id}
                                        >
                                            <StudioCard
                                                studioData={studioData}
                                            />
                                        </Grid>
                                    }
                                    return null
                                })}
                            </Grid>
                        </Paper>
                    </Grid>
                ))}
            </Grid>
            <StudioTagEditDialog
                studioTag={editStudioTag}
                onClose={isEdit => {
                    setEditStudioTag(undefined)
                    if (isEdit) {
                        if (storeObjectState.storeData?.str_id) {
                            reloadStudioTagList(storeObjectState.storeData?.str_id)
                        }
                    }
                }}
            />
        </Paper>
    );
}

export default StoreDetailStudioTagEdit